import parser from "jsonpath-rfc9535/parser";

//#region src/jsonPathToPathArray.ts
const jsonPathToPathArray = (path) => {
	let parsed;
	try {
		parsed = parser(path);
	} catch (error) {
		throw new Error(`Error parsing JSONPath "${path}"`, { cause: error });
	}
	return parsed.segments.flatMap((segment) => {
		if (segment.type === "ChildSegment") {
			const node = segment.node;
			if (node.type === "MemberNameShorthand") return {
				type: "key",
				value: node.value
			};
			else if (node.type === "BracketedSelection") return node.selectors.map((selector) => {
				if (selector.type === "NameSelector") return {
					type: "key",
					value: selector.value
				};
				else if (selector.type === "WildcardSelector") return { type: "wildcard" };
				else throw new Error(`Unsupported node: ${JSON.stringify(node)}`);
			});
			else if (node.type === "WildcardSelector") return { type: "wildcard" };
			else throw new Error(`${segment.type} node type not supported`);
		} else throw new Error(`${segment.type} segment type not supported`);
	});
};

//#endregion
export { jsonPathToPathArray };